<cs-header>
  <cs-header-title>{{ LL.barcodeScanner.title() }}</cs-header-title>
  <cs-header-content>
    <div class="segment-container">
      <cs-segment [selection]="activeTab" (selectionChange)="onTabChange($event)">
        <cs-segment-button [value]="BarcodeScannerTab.Scan">
          {{ LL.barcodeScanner.tabs.scan() }}
        </cs-segment-button>
        <cs-segment-button [value]="BarcodeScannerTab.EnterManually">
          {{ LL.barcodeScanner.tabs.enterManually() }}
        </cs-segment-button>
      </cs-segment>
    </div>
  </cs-header-content>
</cs-header>
<!-- Scan Tab Content -->
@if (activeTab === BarcodeScannerTab.Scan) {
  <div class="scan-tab-content">
    <!-- Camera Permission Denied - Show Instructions -->
    @if (camera.cameraPermissionDismissed) {
      <cs-content>
        <cs-scanner-permission-denied [scanner]="ScannerName.Barcode"
          [message]="LL.barcodeScanner.messages.cameraPermissionDenied()"></cs-scanner-permission-denied>
      </cs-content>
    }
    <!-- Camera Section -->
    @if (!camera.cameraPermissionDismissed && (cameraStartedTime || !camera.permissionStatus || camera.permissionStatus.state === 'granted' || camera.permissionStatus.state === 'prompt')) {
      <cs-content class="camera-section" [no-scroll]="true">
        <div class="camera-holder" [class.camera-holder-ready]="cameraReady">
          <cs-camera-view #cameraView [aspectRatio]="'1:1'" [cameraService]="camera"
            (cameraReady)="onCameraReady()"
            (cameraError)="onCameraError($event)"
            (permissionChange)="onPermissionChange()">
            <cs-barcode-detector
              [types]="barcodeFormats"
              (detected)="onBarcodeDetected($event)"
              (processed)="onFrameProcessed($event)" />
          </cs-camera-view>
          @if (!cameraReady) {
            <!-- page-level spinner overlay until cs-camera-view emits
                 (cameraReady). cs-camera-view stays mounted (hidden via CSS)
                 so it can still measure its frame rect for the native plugin. -->
            <div class="camera-init-spinner">
              <cs-spinner></cs-spinner>
            </div>
          }
        </div>
      </cs-content>
    }
  </div>
}

<!-- Enter Manually Tab Content -->
@if (activeTab === BarcodeScannerTab.EnterManually) {
  <cs-content>
    <cs-card-list>
      <cs-card class="manual-entry-card">
        <p class="manual-entry-title">{{ LL.barcodeScanner.manualEntry.title() }}</p>
        <div class="manual-entry-form">
          <cs-input autocomplete="off" type="text" inputmode="numeric" id="manualCodeInput"
            #manualCodeInputCtrl [(value)]="manualCodeInput" (keyup.enter)="handleManualCodeConfirmed()" />
          <!-- Desktop only: inline button -->
          <cs-button class="desktop-only" primary small (click)="handleManualCodeConfirmed()" [disabled]="!manualCodeInput">
            {{ LL.barcodeScanner.manualEntry.findFood() }}
          </cs-button>
        </div>
      </cs-card>
    </cs-card-list>
  </cs-content>
}

<!-- Mobile only: page action button -->
@if (activeTab === BarcodeScannerTab.EnterManually) {
  <cs-page-action-buttons class="mobile-only">
    <cs-button primary [label]="LL.barcodeScanner.manualEntry.findFood()"
    (click)="handleManualCodeConfirmed()" [disabled]="!manualCodeInput"></cs-button>
  </cs-page-action-buttons>
}
